// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===========================
   Blogs Section (List)
   =========================== */
.blogs-section {
  padding: 80px 0;
}

.blogs-heading-wrap {
  margin-bottom: 00px;
  padding-left: 15px;
}

.blogs-section-heading {
  font-size: var(--font-size-xxxlarge);
  font-weight: var(--font-bold);
  font-family: var(--font-codec-cold);
  line-height: 1.2;
}

.blogs-heading-purple {
  color: var(--primary-color);
}

.blogs-heading-black {
  color: var(--text-black);
}

/* View All Post Button */
.view-all-post-btn {
  font-size: 19px;
  color: #6318C6;
  font-family: var(--font-codec-cold);
  border-radius: 50px;
  border: 1px solid #6318C6;
  height: 45px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 30px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.view-all-post-btn:hover {
  background-color: #6318C6;
  color: white;
  text-decoration: none;
}

/* Blog Card */
.blog-card-link {
  text-decoration: none;
  display: block;
}

.blog-card {
  background: linear-gradient(#ffffff, #ffffff) padding-box,
    linear-gradient(180deg, #6318C6 0%, #F2CC00 100%) border-box;
  border: 2px solid transparent;
  border-radius: 6px 60px 6px 60px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
}


/* .blog-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #FFD700 0%, #7B2FF7 100%);
  border-radius: 0 0 4px 4px;
} */

/* .blog-card:hover { */
/* transform: translateY(-6px); */
/* box-shadow: 0 12px 35px rgba(123, 47, 247, 0.50); */
/* } */

.blog-card-img-wrap {
  width: 100%;
  overflow: hidden;
  border-radius: 6px 60px 6px 0px;
  height: 220px;
}

.blog-card-img {
  border-radius: 0px 60px 6px 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}

.blog-card:hover .blog-card-img {
  transform: scale(1.04);
}

.blog-card-body {
  padding: 20px 22px 30px 22px;
  text-align: left;
}

.blog-image img {
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1),
    inset 0 0 0 1.5px #B9B9B9;
}

.blog-image {
  margin: 25px 0 30px 0px;
}

.blog-card-title {
  font-size: 22px;
  font-weight: 600;
  color: #070707;
  font-family: var(--font-montserrat);
  line-height: 1.4;
  margin-bottom: 12px;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.blog-card-date {
  font-size: 17px;
  color: #656565;
  font-family: var(--font-montserrat-semibold);
  margin: 0;
}

/* ===========================
   Blog Detail Page
   =========================== */
.blog-detail-page {
  background-color: #fff;
}

/* Hero */
.blog-detail-hero {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 460px;
  padding: 125px 0 40px;
  background: linear-gradient(270deg, rgba(242, 204, 0, 0.4) 0%, rgba(99, 24, 198, 0.4) 100%);
}

.blog-detail-title {
  font-size: var(--font-size-xxxlarge);
  font-weight: var(--font-bold);
  color: var(--primary-color);
  font-family: var(--font-montserrat-semibold);
  line-height: 1.4;
  margin: 0;
}

/* Body */
.blog-detail-body {
  padding: 60px 0 80px;
}

/* Sections */
.blog-section {
  margin-bottom: 48px;
}

.blog-section-heading {
  font-size: var(--font-size-xlarge);
  color: var(--text-black);
  font-family: var(--font-montserrat-bold);
  font-weight: 700;
  margin-bottom: 18px;
  line-height: 1.3;
}

.blog-para {
  font-size: var(--font-size-regular);
  color: var(--text-black);
  line-height: 1.6;
  margin-bottom: 20px;
  font-family: var(--font-montserrat-medium);
}

/* Check List */
.blog-check-list {
  list-style: none;
  padding: 0;
  margin: 32px 0 20px 0;
}

.blog-check-list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: var(--font-size-regular);
  font-family: var(--font-montserrat-semibold);
  font-weight: 700;
  color: #0E0E0E;
  margin-bottom: 12px;
  line-height: 1.6;
}

.blog-check-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin-top: 0px;
}

.blog-highlight-block {
  margin-top: 30px;
  margin-bottom: 35px;
}

.checklist2 li {
  position: relative;
}

.checklist2 li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 12px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #000;
}

.blog-highlight-title {
  font-size: 21px;
  color: #0E0E0E;
  font-family: var(--font-montserrat-semibold);
  margin-bottom: 14px;
  font-weight: 700;
}

.blog-check-list.checklist2 li {
  font-family: var(--font-montserrat-medium);
  font-weight: 500;
  margin-bottom: 0px;
  padding-left: 15px;
}

.blog-check-list.checklist2 {
  list-style: circle !important;
  padding-left: 0px;
}

/* Link */
.blog-link {
  color: var(--primary-color);
  text-decoration: underline;
  font-family: var(--font-montserrat-medium);
  font-weight: 500;
  font-size: var(--font-size-regular);
  word-break: break-all;
}

.blog-link:hover {
  color: var(--primary-color);
  opacity: 0.8;
}

.list-section {
  padding-top: 80px;
  background-color: #fff;
}


/* ===========================
   Responsive
   =========================== */
@media (max-width: 767px) {
  .blogs-section {
    padding: 50px 0;
  }

  .list-section {
    padding-top: 53px !important;
  }

  .view-all-post-btn {
    font-size: 15px !important;
    height: 40px !important;
  }

  .blogs-section-heading {
    font-size: var(--font-size-xlarge);
  }

  .blog-card-img-wrap {
    height: 180px;
  }

  .blog-card-title {
    font-size: var(--font-size-xsmall);
  }

  .blog-highlight-block {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }

  .blog-detail-hero {
    padding: 82px 0 30px;
  }

  .blog-highlight-title {
    font-size: 15px !important;
  }

  .blog-link {
    font-size: var(--font-size-small) !important;
  }

  .blog-detail-hero {
    min-height: 290px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .blog-detail-title {
    font-size: var(--font-size-medium);
  }

  .blog-section-heading {
    font-size: var(--font-15);
  }

  .blog-para {
    font-size: var(--font-size-small);
  }

  .blog-check-icon {
    width: 26px;
    height: 23px;
  }

  .blog-check-list li {
    font-size: var(--font-size-small);
  }

  .blog-highlight-block {
    padding: 0px 0px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .blogs-section-heading {
    font-size: var(--font-size-xxlarge);
  }

  .blog-detail-title {
    font-size: var(--font-size-xxlarge);
  }

  .blog-section-heading {
    font-size: var(--font-size-large);
  }
}

.blogs-list-page {
  padding-top: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/Website/Blogs/Blogs.css"],"names":[],"mappings":"AAAA;;gCAEgC;AAChC;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,+CAA+C;EAC/C,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;gEAC8D;EAC9D,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;EAChB,qDAAqD;EACrD,kBAAkB;EAClB,+CAA+C;EAC/C,WAAW;AACb;;;AAGA;;;;;;;;;GASG;;AAEH,uBAAuB;AACvB,iCAAiC;AACjC,sDAAsD;AACtD,MAAM;;AAEN;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB;6BAC2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;;EAEnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4CAA4C;EAC5C,SAAS;AACX;;AAEA;;gCAEgC;AAChC;EACE,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,4CAA4C;EAC5C,gBAAgB;EAChB,SAAS;AACX;;AAEA,SAAS;AACT;EACE,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mCAAmC;EACnC,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,0CAA0C;EAC1C,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;;AAGA;;gCAEgC;AAChC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* ===========================\n   Blogs Section (List)\n   =========================== */\n.blogs-section {\n  padding: 80px 0;\n}\n\n.blogs-heading-wrap {\n  margin-bottom: 00px;\n  padding-left: 15px;\n}\n\n.blogs-section-heading {\n  font-size: var(--font-size-xxxlarge);\n  font-weight: var(--font-bold);\n  font-family: var(--font-codec-cold);\n  line-height: 1.2;\n}\n\n.blogs-heading-purple {\n  color: var(--primary-color);\n}\n\n.blogs-heading-black {\n  color: var(--text-black);\n}\n\n/* View All Post Button */\n.view-all-post-btn {\n  font-size: 19px;\n  color: #6318C6;\n  font-family: var(--font-codec-cold);\n  border-radius: 50px;\n  border: 1px solid #6318C6;\n  height: 45px;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 30px;\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\n\n.view-all-post-btn:hover {\n  background-color: #6318C6;\n  color: white;\n  text-decoration: none;\n}\n\n/* Blog Card */\n.blog-card-link {\n  text-decoration: none;\n  display: block;\n}\n\n.blog-card {\n  background: linear-gradient(#ffffff, #ffffff) padding-box,\n    linear-gradient(180deg, #6318C6 0%, #F2CC00 100%) border-box;\n  border: 2px solid transparent;\n  border-radius: 6px 60px 6px 60px;\n  overflow: hidden;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  position: relative;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  width: 100%;\n}\n\n\n/* .blog-card::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, #FFD700 0%, #7B2FF7 100%);\n  border-radius: 0 0 4px 4px;\n} */\n\n/* .blog-card:hover { */\n/* transform: translateY(-6px); */\n/* box-shadow: 0 12px 35px rgba(123, 47, 247, 0.50); */\n/* } */\n\n.blog-card-img-wrap {\n  width: 100%;\n  overflow: hidden;\n  border-radius: 6px 60px 6px 0px;\n  height: 220px;\n}\n\n.blog-card-img {\n  border-radius: 0px 60px 6px 0px;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform 0.4s ease;\n}\n\n.blog-card:hover .blog-card-img {\n  transform: scale(1.04);\n}\n\n.blog-card-body {\n  padding: 20px 22px 30px 22px;\n  text-align: left;\n}\n\n.blog-image img {\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1),\n    inset 0 0 0 1.5px #B9B9B9;\n}\n\n.blog-image {\n  margin: 25px 0 30px 0px;\n}\n\n.blog-card-title {\n  font-size: 22px;\n  font-weight: 600;\n  color: #070707;\n  font-family: var(--font-montserrat);\n  line-height: 1.4;\n  margin-bottom: 12px;\n\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.blog-card-date {\n  font-size: 17px;\n  color: #656565;\n  font-family: var(--font-montserrat-semibold);\n  margin: 0;\n}\n\n/* ===========================\n   Blog Detail Page\n   =========================== */\n.blog-detail-page {\n  background-color: #fff;\n}\n\n/* Hero */\n.blog-detail-hero {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 460px;\n  padding: 125px 0 40px;\n  background: linear-gradient(270deg, rgba(242, 204, 0, 0.4) 0%, rgba(99, 24, 198, 0.4) 100%);\n}\n\n.blog-detail-title {\n  font-size: var(--font-size-xxxlarge);\n  font-weight: var(--font-bold);\n  color: var(--primary-color);\n  font-family: var(--font-montserrat-semibold);\n  line-height: 1.4;\n  margin: 0;\n}\n\n/* Body */\n.blog-detail-body {\n  padding: 60px 0 80px;\n}\n\n/* Sections */\n.blog-section {\n  margin-bottom: 48px;\n}\n\n.blog-section-heading {\n  font-size: var(--font-size-xlarge);\n  color: var(--text-black);\n  font-family: var(--font-montserrat-bold);\n  font-weight: 700;\n  margin-bottom: 18px;\n  line-height: 1.3;\n}\n\n.blog-para {\n  font-size: var(--font-size-regular);\n  color: var(--text-black);\n  line-height: 1.6;\n  margin-bottom: 20px;\n  font-family: var(--font-montserrat-medium);\n}\n\n/* Check List */\n.blog-check-list {\n  list-style: none;\n  padding: 0;\n  margin: 32px 0 20px 0;\n}\n\n.blog-check-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  font-size: var(--font-size-regular);\n  font-family: var(--font-montserrat-semibold);\n  font-weight: 700;\n  color: #0E0E0E;\n  margin-bottom: 12px;\n  line-height: 1.6;\n}\n\n.blog-check-icon {\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  margin-top: 0px;\n}\n\n.blog-highlight-block {\n  margin-top: 30px;\n  margin-bottom: 35px;\n}\n\n.checklist2 li {\n  position: relative;\n}\n\n.checklist2 li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 12px;\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background-color: #000;\n}\n\n.blog-highlight-title {\n  font-size: 21px;\n  color: #0E0E0E;\n  font-family: var(--font-montserrat-semibold);\n  margin-bottom: 14px;\n  font-weight: 700;\n}\n\n.blog-check-list.checklist2 li {\n  font-family: var(--font-montserrat-medium);\n  font-weight: 500;\n  margin-bottom: 0px;\n  padding-left: 15px;\n}\n\n.blog-check-list.checklist2 {\n  list-style: circle !important;\n  padding-left: 0px;\n}\n\n/* Link */\n.blog-link {\n  color: var(--primary-color);\n  text-decoration: underline;\n  font-family: var(--font-montserrat-medium);\n  font-weight: 500;\n  font-size: var(--font-size-regular);\n  word-break: break-all;\n}\n\n.blog-link:hover {\n  color: var(--primary-color);\n  opacity: 0.8;\n}\n\n.list-section {\n  padding-top: 80px;\n  background-color: #fff;\n}\n\n\n/* ===========================\n   Responsive\n   =========================== */\n@media (max-width: 767px) {\n  .blogs-section {\n    padding: 50px 0;\n  }\n\n  .list-section {\n    padding-top: 53px !important;\n  }\n\n  .view-all-post-btn {\n    font-size: 15px !important;\n    height: 40px !important;\n  }\n\n  .blogs-section-heading {\n    font-size: var(--font-size-xlarge);\n  }\n\n  .blog-card-img-wrap {\n    height: 180px;\n  }\n\n  .blog-card-title {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .blog-highlight-block {\n    margin-top: 10px !important;\n    margin-bottom: 10px !important;\n  }\n\n  .blog-detail-hero {\n    padding: 82px 0 30px;\n  }\n\n  .blog-highlight-title {\n    font-size: 15px !important;\n  }\n\n  .blog-link {\n    font-size: var(--font-size-small) !important;\n  }\n\n  .blog-detail-hero {\n    min-height: 290px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .blog-detail-title {\n    font-size: var(--font-size-medium);\n  }\n\n  .blog-section-heading {\n    font-size: var(--font-15);\n  }\n\n  .blog-para {\n    font-size: var(--font-size-small);\n  }\n\n  .blog-check-icon {\n    width: 26px;\n    height: 23px;\n  }\n\n  .blog-check-list li {\n    font-size: var(--font-size-small);\n  }\n\n  .blog-highlight-block {\n    padding: 0px 0px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .blogs-section-heading {\n    font-size: var(--font-size-xxlarge);\n  }\n\n  .blog-detail-title {\n    font-size: var(--font-size-xxlarge);\n  }\n\n  .blog-section-heading {\n    font-size: var(--font-size-large);\n  }\n}\n\n.blogs-list-page {\n  padding-top: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
